module.exports = __webpack_public_path__ + "img/Android.c7c2b6f.svg";